module.exports = __webpack_public_path__ + "img/user_FangKun.85c72d6a.png";